import { ShieldCheck, Truck, Users, Award } from "lucide-react";
import { Analytics } from "@/lib/analyticsShim";

const STATS = [
  { icon: Users, value: "Procure", label: "Materials Faster" },
  { icon: Truck, value: "Track", label: "Projects & Materials" },
  { icon: ShieldCheck, value: "Manage", label: "Site Operations" },
  { icon: Award, value: "Report", label: "With Better Visibility" },
];

export default function AboutUs() {
  return (
    <section id="about" className="py-20 md:py-28 px-6 md:px-10 bg-[#F9FAFB]" data-testid="about-section">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div>
          <div className="section-label">About RailAxis</div>
          <h2 className="font-display font-bold text-3xl md:text-4xl lg:text-5xl text-[#111827] mt-2 tracking-tight leading-[1.1]">
            Where infrastructure moves faster.
          </h2>
          <p className="mt-6 text-[#4B5563] text-base md:text-lg leading-relaxed">
            RailAxis is a technology-driven platform built for the infrastructure and construction industry.
            We help contractors and project teams procure materials, track projects, and manage site operations
            more efficiently.
          </p>
          <p className="mt-4 text-[#4B5563] text-base leading-relaxed">
            Our platform connects procurement, project management, material tracking, and reporting into one
            ecosystem. We aim to simplify infrastructure execution through faster coordination and better visibility.
          </p>
          <p className="mt-4 text-[#4B5563] text-base leading-relaxed">
            RailAxis supports railway, construction, EPC, and industrial projects across India. We believe in
            honest communication, operational reliability, and long-term relationships.
          </p>
          <p className="mt-4 text-[#4B5563] text-base leading-relaxed">
            Our focus is to reduce delays, improve execution, and make project management smarter. We are building
            digital solutions designed specifically for infrastructure companies and contractors. RailAxis is
            committed to improving how infrastructure projects operate in India.
          </p>
          <p className="mt-5 font-display text-xl font-bold text-[#111827]">
            Built for Builders. By Builders.
          </p>

          <div className="grid grid-cols-2 gap-6 mt-10">
            {STATS.map((s) => (
              <div key={s.label} className="flex items-start gap-3" data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, '-')}`}>
                <div className="w-10 h-10 rounded-md bg-[#C8A96A]/15 flex items-center justify-center shrink-0">
                  <s.icon className="w-5 h-5 text-[#C8A96A]" />
                </div>
                <div>
                  <div className="font-display font-bold text-xl text-[#111827]">{s.value}</div>
                  <div className="text-sm text-[#4B5563]">{s.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <img
            src="https://images.pexels.com/photos/8961260/pexels-photo-8961260.jpeg?auto=compress&cs=tinysrgb&w=800"
            alt="Construction site"
            className="rounded-xl object-cover w-full h-72 row-span-2"
            data-testid="about-img-1"
          />
          <img
            src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&q=80"
            alt="Steel yard"
            className="rounded-xl object-cover w-full h-56"
            data-testid="about-img-2"
          />
          <img
            src="https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=600&q=80"
            alt="Team"
            className="rounded-xl object-cover w-full h-56"
            data-testid="about-img-3"
          />
        </div>
      </div>
    </section>
  );
}
